function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
import color from 'color';
export default (function (_ref) {
  var colors = _ref.colors,
    mediaQueries = _ref.mediaQueries;
  return {
    wrapper: _defineProperty({
      position: 'relative',
      display: 'inline-block',
      padding: '0 16px',
      userSelect: 'none',
      cursor: 'pointer',
      verticalAlign: 'middle',
      lineHeight: '16px',
      '&:hover $base': {
        borderColor: colors.primary
      },
      '&:hover $base__selected': {
        borderColor: colors.primaryDarker
      },
      '&:hover $base__error': {
        backgroundColor: colors.white
      }
    }, mediaQueries.breakpointLaptopSmall, {
      display: 'block',
      margin: '10px 0'
    }),
    wrapper__vertical: {
      display: 'block',
      marginBottom: '10px'
    },
    input: {
      position: 'absolute',
      left: '-9999px'
    },
    optionText: {
      padding: '1px 12px',
      display: 'inline-block',
      verticalAlign: 'middle',
      fontSize: '14px'
    },
    base: {
      backgroundColor: colors.white,
      width: '16px',
      height: '16px',
      borderRadius: '100%',
      position: 'absolute',
      top: '50%',
      left: 0,
      transform: 'translateY(-50%)',
      border: "1px solid ".concat(colors.inputBorder),
      transition: 'border .2s'
    },
    base__selected: {
      borderWidth: '4px',
      borderColor: colors.primary
    },
    base__error: {
      borderColor: colors.error,
      backgroundColor: color(colors.error).lighten(0.6).hex()
    },
    textField: {
      marginLeft: '15px'
    }
  };
});